export const iOS = ( navigator.userAgent.match(/(iPad|iPhone|iPod)/g) ? true : false );
export const rootURL = window.location.hostname.indexOf('tombrasweb.com') !== -1 ? 'https://demanddetroit.azurewebsites.net/umbraco/Api' : '/umbraco/Api';
export const mapURL = iOS ? 'http://maps.apple.com/?daddr=' : 'https://www.google.com/maps/?q=';
export const jwpKey = 'xEwXa9XU/SCzKj/Nfo6NTe5UbOa4kcCl6rCAN2+tUuDtjwR+';
export const jwpPlayerId = 'Bwa5mKtT';